// extracted by mini-css-extract-plugin
export default {"signing":"HeaderNavbar_signing__I+fQ7","navGroup":"HeaderNavbar_navGroup__6dT1p"};